import TextMaskedInput, { TextMaskedInputProps } from './TextMaskedInput';

export type { TextMaskedInputProps };
export default TextMaskedInput;
